export const AMPLITUDE_CONFIG = {
  includeReferrer: true,
  // Valid values are 'DISABLE', 'ERROR', 'WARN', 'INFO'
  logLevel: 'WARN'
};
